import React, { useState, useEffect } from 'react';
import { publicCollection } from '../lib/publicContent';
import { useSiteInfo } from '../context/SiteContext';

export interface AdItem {
  id: string;
  title: string;
  type: 'image' | 'html';
  content: string;
  link?: string;
  position: string;
  isActive: boolean;
  order: number;
}

interface AdBlockProps {
  position: string;
  className?: string;
}

export default function AdBlock({ position, className = '' }: AdBlockProps) {
  const [ads, setAds] = useState<AdItem[]>([]);
  const [loading, setLoading] = useState(true);
  const { siteInfo } = useSiteInfo();
  useEffect(() => {
    let cancelled=false;
    publicCollection('ads').then(rows=> {
      if(!cancelled) setAds(rows.filter(a=>a.position===position).sort((a,b)=>(a.order||0)-(b.order||0)));
    }).catch(console.error).finally(()=> {if(!cancelled) setLoading(false);});
    return ()=> {cancelled=true;};
  }, [position]);

  if (loading) return null;

  // Check if slot is globally disabled
  if (siteInfo.bannerSlots && siteInfo.bannerSlots[position] === false) {
    return null;
  }

  const displayAds = ads;

  if (displayAds.length === 0) return null;

  return (
    <div className={`space-y-4 ${className}`}>
      {displayAds.map(ad => (
        <div key={ad.id} className="w-full overflow-hidden flex flex-col items-center justify-center relative group">
          {ad.type === 'image' ? (
            ad.link ? (
              <a href={ad.link} target="_blank" rel="noopener noreferrer" className="block w-full">
                <img src={ad.content} alt={ad.title} className="w-full h-auto object-cover rounded-md shadow-sm opacity-90 hover:opacity-100 transition-opacity" />
              </a>
            ) : (
              <img src={ad.content} alt={ad.title} className="w-full h-auto object-cover rounded-md shadow-sm opacity-90" />
            )
          ) : (
             <div 
               className="w-full bg-gray-50 flex items-center justify-center min-h-[100px]" 
               dangerouslySetInnerHTML={{ __html: ad.content }} 
             />
          )}

          {ads.length === 0 && (
            <div className="absolute top-2 right-2 bg-black bg-opacity-60 text-white text-xs px-2 py-1 rounded">
              Demo Preview (Admin)
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
